import { MatDialogConfig } from '@angular/material/dialog';
import { DeleteServiceOrderDialogData } from './dialog-delete-os.component';

export const DELETE_ORDER_PANEL_CLASS = 'create-order-panel';

export function buildDeleteOrderDialogConfig(
  data: DeleteServiceOrderDialogData,
  options?: { disableClose?: boolean }
): MatDialogConfig<DeleteServiceOrderDialogData> {
  return {
    width: '480px',
    maxWidth: '94vw',
    panelClass: DELETE_ORDER_PANEL_CLASS,
    autoFocus: false,
    disableClose: options?.disableClose ?? false,
    data
  };
}
